export const MAX_CHANNELS_FETCH_AMOUNT = 30
export const CACHE_TRIM_AMOUNT = 200
export const IS_EPG_CACHE_CHECKED = 'isEpgCacheChecked'
export const IS_TV_CACHE_CHECKED = 'isTVCacheChecked'
